import './css/App.css';
import Services from "./pages/services";
import {Product} from "./pages/product";
import IntelligenceProducts from "./pages/intelligence_products";
import ExecutiveIntelligence from "./pages/executive_intelligence";
// import Industries from "./pages/industries";
import Resources from "./pages/resources";
import CrimeMapGallery from "./pages/crime_map_gallery";
import {About} from "./pages/about";
import Contact from "./pages/contact";
import HowClientsUseWeathervane from "./pages/HowClientsUseWeathervane"


import {ScrollToTop} from './components/ScrollToTop';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";

function App() {
  return (
  <div className="App">
    <BrowserRouter>
      <ScrollToTop/>
      <Routes>
        <Route path="/">
          <Route index element = {<Services />} />
          <Route path="product" element = {<Product/>} />
          <Route path="intelligence_products" element = {<IntelligenceProducts/>} />
          <Route path="protective_intelligence" element = {<ExecutiveIntelligence/>} />
          {/* <Route path="industries" element = {<Industries/>} />  */}
          <Route path="use_cases" element = {<HowClientsUseWeathervane/>} /> 
          <Route path="resources" element = {<Resources/>} />
          <Route path="crime_map_gallery" element = {<CrimeMapGallery/>} />
          <Route path="about" element = {<About/>} />
          <Route path="contact" element = {<Contact/>} />
          <Route path="*" element = {<Services />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </div>
  );
}

export default App;
